import { ChevronLeft } from 'lucide-react';
import { DevToolsSegmentedControl } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsSegmentedControl';
import { DebugRecordDevices } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugRecord/DebugRecordDevices';
import { DebugRecordEvents } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugRecord/DebugRecordEvents';
import { DebugRecordHeader } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugRecord/DebugRecordHeader';
import { DebugRecordMedia } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugRecord/DebugRecordMedia';
import { DebugRecordOverview } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugRecord/DebugRecordOverview';
import type { DebugRecordProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/DebugRecord/index.types';
import type { DebugRecordSection } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DebugTab/index.types';
import React, { useState } from 'react';

/**
 * DebugRecord - One captured leg, in full
 *
 * The detail half of the tab.
 */
export const DebugRecord: React.FC<DebugRecordProps> = ({
  info,
  availableLegIds,
  onBack,
  onOpenLeg,
  onDownload,
}) => {
  const [section, setSection] = useState<DebugRecordSection>('overview');
  const eventCount = info.events?.length ?? 0;

  return (
    <div className="flex flex-col gap-3">
      <button
        type="button"
        onClick={onBack}
        className="inline-flex items-center gap-1 self-start rounded-[7px] border border-zinc-800 py-1 pl-1.5 pr-[9px] text-[11.5px] text-zinc-300 transition-colors hover:bg-zinc-800 hover:text-zinc-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400/40"
      >
        <ChevronLeft className="h-3.5 w-3.5" />
        History
      </button>

      <DebugRecordHeader info={info} onDownload={onDownload} />

      <DevToolsSegmentedControl<DebugRecordSection>
        label="Record section"
        value={section}
        onChange={setSection}
        options={[
          { value: 'overview', label: 'Overview' },
          { value: 'events', label: 'Events', badge: eventCount },
          { value: 'media', label: 'SDP / ICE' },
          { value: 'devices', label: 'Devices' },
        ]}
      />

      {section === 'overview' && (
        <DebugRecordOverview
          info={info}
          onOpenLeg={onOpenLeg}
          availableLegIds={availableLegIds}
        />
      )}
      {section === 'events' && <DebugRecordEvents events={info.events} />}
      {section === 'media' && <DebugRecordMedia info={info} />}
      {section === 'devices' && <DebugRecordDevices info={info} />}
    </div>
  );
};
